import { ColumnOrderState } from '@tanstack/react-table';

// A saved view only lists the columns that existed when it was saved, and
// react-table renders anything the order doesn't mention after everything it
// does. Every other reader of the order has to agree with that, or a field
// added since the view was saved reads as first in the fields sidebar while it
// sits last in the table - and dragging it moves whichever column is at the end
// instead, because arrayMove takes indexOf's -1 as "the last one".

export const withMissingColumnsAtEnd = (
  order: ColumnOrderState,
  availableColumnIds: Array<string>
): ColumnOrderState => {
  const missing = availableColumnIds.filter((id) => !order.includes(id));

  return missing.length === 0 ? order : [...order, ...missing];
};

export const getColumnOrderIndex = (order: ColumnOrderState, id: string) => {
  const index = order.indexOf(id);

  return index === -1 ? Number.MAX_SAFE_INTEGER : index;
};
